import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P } from "../../AbstractElements";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import {
  companyprofileService,
  VIEW_COMPANY_QUERY_KEY,
} from "../../Services/companyProfileService";
import { ViewCompanyProfile } from "../../Types/CompanyProfile/CompanyProfile";
import Swal from "sweetalert2";
import CompanyData from "./CompanyProfile/CompanyData";
import CompanyDetails from "./CompanyProfile/CompanyDetails";

const CompanyProfileContainer = () => {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();

  const {
    data: companyData,
    isLoading,
    error,
  } = useQuery<{ data: ViewCompanyProfile }, any>({
    queryKey: [VIEW_COMPANY_QUERY_KEY, code],
    queryFn: () => companyprofileService.getViewCompanyProfile(code as string),
    enabled: !!code,
    retry: false,
  });

  const company = companyData?.data;

  useEffect(() => {
    if (error?.response?.status === 404) {
      Swal.fire({
        icon: "error",
        title: "Company Not Found",
        text: "The company you are looking for does not exist.",
        confirmButtonText: "Go to Dashboard",
      }).then(() => {
        navigate(`${process.env.PUBLIC_URL}/dashboard`, { replace: true });
      });
    }
  }, [error, navigate]);

  if (isLoading) return null;

  return (
    <>
      <Breadcrumbs
        mainTitle={`${company?.company ?? "Loading..."}`}
        parent="Company Profile"
      />
      <Container fluid>
        <div className="user-profile">
          <Row>
            <CompanyData companyInfo={company} />
          </Row>
          <CompanyDetails companyInfo={company} />
        </div>
      </Container>
    </>
  );
};

export default CompanyProfileContainer;
